import './BaseSwiper.e5c515bbfd69327059c91f5bd2ae0110.css';
export default {"swiperContainer":"_swiperContainer_tgozb_1"};